export const ItemTypes = {
  PIECES: ['knight', 'bishop', 'pawn', 'rook', 'queen', 'king'],
  KNIGHT: 'knight',
  PAWN: 'pawn',
  ROOK: 'rook',
  BISHOP: 'bishop',
  QUEEN: 'queen',
  KING: 'king',
  PIECE: 'piece'
};



/** WEBPACK FOOTER **
 ** ./constants/item_types.js
 **/